import { useEffect } from 'react'
import { useLocation } from '@muse-web/router'
import { localStorage } from '@muse-web/storages'

import { LAST_VISIT_TIMESTAMP_KEY } from '../constants/storageKeys'

/**
 * Records the timestamp of the last visited screen (used by return-visitor / promo
 * logic). Renders nothing.
 *
 * NOTE: audio-web excluded the MarketingRedirect route; that route has no equivalent
 * in the new stack yet — re-add the guard here if/when it is migrated.
 */
export const LastVisitTracker = () => {
    const { pathname } = useLocation()

    useEffect(() => {
        localStorage.set(LAST_VISIT_TIMESTAMP_KEY, Date.now())
    }, [pathname])

    return null
}
